import org from './org'
import orgRealback from './orgRealback'
import person from './person'
import invite from './invite'
import inviteJoin from './inviteJoin'
import qw from './qw'
import cloud from './cloud'
export default {
  namespaced: true,
  modules: {
    org,
    orgRealback,
    person,
    invite,
    inviteJoin,
    qw,
    cloud
  }
}
